<div>
	<mat-card-header>
		<mat-card-title>
			Email Domains
		</mat-card-title>
	</mat-card-header>
	<mat-divider> </mat-divider>

	<mat-card-content class="row margin-top-sm">
		<mat-card appearance="outlined" class="col-lg-6">
			<mat-card-header>
				<mat-card-title>
					Search Criteria
				</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<mat-form-field class="col-lg-12">
					<mat-label>
						Email Domain
					</mat-label>
					<input matInput id="searchString" name="searchString" type="string" [(ngModel)]="searchString"
						(keyup.enter)="searchEmailDomains(searchString)" />
				</mat-form-field>
			</mat-card-content>
			<mat-card-actions>
				<button mat-raised-button color="primary" mat-button
					[disabled]="(this.searchString.length === 0) || isLoading"
					(click)="searchEmailDomains(searchString)" class="margin-right-xs">
					<mat-icon *ngIf="isLoading">
						<mat-spinner diameter="18"> </mat-spinner>
					</mat-icon>
					Search
				</button>
				<button mat-raised-button color="" (click)="indexEmailDomains()" [disabled]="isLoading">
					<mat-icon *ngIf="isLoading">
						<mat-spinner diameter="18"> </mat-spinner>
					</mat-icon>
					Show all Email Domains
				</button>
			</mat-card-actions>
		</mat-card>
	</mat-card-content>

	<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

	<div class="margin-top-md">
		<mat-card-header>
			<mat-card-title>
				<div *ngIf="results && results.length > 0">
					Search Results

					({{(tableDataSources[0] ? (tableDataSources[0].filteredData.length < results.length ?
						tableDataSources[0].filteredData.length + '/' : '' ) : '' ) + results.length}}) </div>
						<div *ngIf="!results || results.length === 0">
							Search Results
						</div>
			</mat-card-title>
		</mat-card-header>


		<div class="row">
			<mat-form-field class="col-lg-12">
				<mat-label>
					Filter
				</mat-label>
				<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
					(ngModelChangeDebounced)="setFilter()" />
			</mat-form-field>
		</div>
		<mat-table [dataSource]="tableDataSources[0]" class="table-responsive mat-elevation-z1" matSort>
			<form [formGroup]="editingForm">
				<ng-container matColumnDef="EDIT">
					<mat-header-cell *matHeaderCellDef> </mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div *ngIf="element.ID !== editingId">
							<button mat-icon-button color="primary" (click)="editEmailDomain(element)"
								matTooltip="Edit">
								<mat-icon>edit</mat-icon>
							</button>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
								[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
								[popoverConfirmColor]="'warn'" [tooltip]="'Delete'"
								(onConfirm)="deleteEmailDomain(element)">
							</confirm-popover>
						</div>
						<div *ngIf="element.ID === editingId">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'check'" [color]="'primary'"
								[popoverMsg]="'Update Email Domain'" [popoverConfirmText]="'Confirm'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Update'"
								(onConfirm)="confirmEditEmailDomain()"
								[disabled]="!editingForm.valid && (this.emailDomainOrganization.ID! > 0 || this.emailDomainOrganization.NAME === '')">
							</confirm-popover>

							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'"
								(onConfirm)="cancelEditEmailDomain()">
							</confirm-popover>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="EMAIL_DOMAIN">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Email Domain </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row">
						<div *ngIf="element.ID !== editingId">
							{{element.EMAIL_DOMAIN}}
						</div>
						<div *ngIf="element.ID === editingId" class="col-lg-12">
							<mat-form-field class="mat-form-field-padding w-100">
								<mat-label>
									Email Domain
								</mat-label>
								<input matInput type="string" placeholder="Email Domain Name"
									formControlName="emailDomain" />
							</mat-form-field>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="ORGANIZATION.NAME">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Organization </mat-header-cell>
					<mat-cell *matCellDef="let element" class="row">
						<div *ngIf="element.ID !== editingId">
							{{element.ORGANIZATION?.NAME}}
						</div>
						<div *ngIf="element.ID === editingId" class="col-lg-12">
							<input-organization-autocomplete class="mat-form-field-padding w-100" [id]="'Organization'"
								[name]="'Organization'" [label]="'Email Domain\'s Organization'"
								[placeholder]="'Search Organization'" [(selectedOrganization)]="emailDomainOrganization"
								[required]="false" [additionalErrorMsg]="'Optional'">
							</input-organization-autocomplete>
						</div>
					</mat-cell>
				</ng-container>
			</form>

			<ng-container matColumnDef="ADD">
				<mat-header-cell *matHeaderCellDef>
					<div *ngIf="!adding && !isLoading">
						<button mat-raised-button color="primary" (click)="addEmailDomain()">New Email
							Domain</button>
					</div>

					<mat-icon *ngIf="isLoading">
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
				</mat-header-cell>
			</ng-container>

			<form [formGroup]="addingForm">
				<ng-container matColumnDef="ADD_EDIT" disabled>
					<mat-header-cell *matHeaderCellDef>
						<div *ngIf="adding">
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
								[popoverMsg]="'Add new Email Domain'" [popoverConfirmText]="'Add'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Add'"
								(onConfirm)="confirmAddEmailDomain()"
								[disabled]="!addingForm.valid || !emailDomainOrganizationValid()">
							</confirm-popover>
							<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
								[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'" [popoverCancelText]="'No'"
								[popoverConfirmColor]="'primary'" [tooltip]="'Cancel'"
								(onConfirm)="cancelAddEmailDomain()">
							</confirm-popover>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_EMAIL_DOMAIN">
					<mat-header-cell *matHeaderCellDef class="row">
						<div class="col-lg-12">
							<mat-form-field class="mat-form-field-padding w-100">
								<mat-label>
									Email Domain
								</mat-label>
								<input matInput type="string" placeholder="Email Domain Name"
									formControlName="emailDomain" />
							</mat-form-field>
						</div>
					</mat-header-cell>
				</ng-container>

				<ng-container matColumnDef="ADD_ORGANIZATION">
					<mat-header-cell *matHeaderCellDef class="row">
						<div class="col-lg-12">
							<input-organization-autocomplete class="mat-form-field-padding w-100" [id]="'Organization'"
								[name]="'Organization'" [label]="'Email Domain\'s Organization'"
								[placeholder]="'Search Organization'" [(selectedOrganization)]="emailDomainOrganization"
								[required]="false" [additionalErrorMsg]="'Optional'">
							</input-organization-autocomplete>
						</div>
					</mat-header-cell>
				</ng-container>
			</form>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matHeaderRowDef="newDisplayedColumns"></mat-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		</mat-table>

		<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements">
		</mat-paginator>
	</div>
</div>